import { RatingBar } from 'components/RatingBar';
import { Colors } from 'constants/ui';

import * as styled from '../styles/reputation';

const GREEN_THRESHOLD = 4.0;
const AMBER_THRESHOLD = 3.2;

const colorForAverage = (value: number): string => {
  if (value >= GREEN_THRESHOLD) return Colors.success;
  if (value >= AMBER_THRESHOLD) return Colors.amber;
  return Colors.errorRed;
};

type Props = {
  categoryAverages: Kudable.CategoryAverage[];
};

export const ReputationBreakdown = ({ categoryAverages }: Props) => {
  if (categoryAverages.length === 0) return null;

  const sorted = [...categoryAverages].sort(
    (first, second) => second.average - first.average,
  );

  return (
    <styled.Container>
      {sorted.map(({ category, average }) => (
        <RatingBar
          key={category}
          label={category}
          value={average}
          accentColor={colorForAverage(average)}
        />
      ))}
    </styled.Container>
  );
};
